import { string } from "prop-types";
import { Lock } from "lucide-react";
import "./BuyLockPill.scss";

const BuyLockPill = ({ label }) => {
  return (
    <span className="buy-lock-pill" aria-hidden>
      <Lock
        size={11}
        color="#fff"
        strokeWidth={2.4}
        className="buy-lock-pill__icon"
      />
      <span className="buy-lock-pill__label">{label}</span>
    </span>
  );
};

BuyLockPill.propTypes = {
  label: string,
};

BuyLockPill.defaultProps = {
  label: "BUY",
};

export default BuyLockPill;
